import React, { Component } from 'react';

import { badgeConfig } from './../../../conf/config';

import Image from './../../../containers/UI/Image/Image';

// Assets
//import GiftImg from './../../../assets/images/gift.png';
import GiftImg from './../../../assets/images/icons/boutique.svg';

export default class HistoryEntry extends Component {  
    
    formatDate = (timestamp) => {
        let actionDate = new Date(timestamp);
        let month = actionDate.getMonth() +1;
        let dateString = (actionDate.getDate() < 10? '0' + actionDate.getDate() : actionDate.getDate()) + '/';
        dateString += (month < 10? '0' + month : month) + '/';
        dateString += actionDate.getFullYear().toString().substr(-2);
        return dateString;
    }

    generateBlocs = (entry) => {
  
        let title, entryImage, image;
        let subtext = entry.entity.entityValue;
        let imgClass = "";
        let points = true;
        let ask = false;
        
        switch(entry.action)
        {
            case 'read':
                title = "Gagné en lisant l'article ";
                break;
            case 'react':
                title = "Gagnés en réagissant à l'article ";
                break;
            case 'comment':
                title = "Gagnés en commentant l'article ";
                break;
            case 'answer':
                title = "Gagnés en répondant au quiz de l'article ";
                break;
            case 'ask':
                title = "Gagnés en posant une question à un journaliste";
                subtext = "";
                ask=true;
                break;
            case 'order':
                title = "J'ai dépensé " + entry.points + " points pour le cadeau ";
                points = false;
                imgClass = " gift";
                image = GiftImg;
                break;
            case 'refund':
                title = "J’ai récupéré " + entry.points + " points car ma commande n’a pas été validée pour le cadeau ";
                points = false;
                imgClass = " gift";
                image = GiftImg;
                break;
            case 'unlock':
                title = "J'ai débloqué le nouveau badge ";
                subtext = badgeConfig[entry.entity.entityId]['name'];
                points = false;
                imgClass = " badge";
                image = badgeConfig[entry.entity.entityId]['imgHover'];
                break;
            case 'gift':
                title = entry.entity.entityValue + " ";
                subtext = entry.value;
                break;
            case 'birthday':
                title = 'Joyeux anniversaire ! ';
                subtext = 'De la part de toute l\'équipe de Kids-Matin';
                break;
            default: 
                title = "Oups je n'ai pas cette action ";
                subtext = "et on sait même pas comment ça se fait ahahah";
                points = false;
                image = GiftImg;
        }

        if( points ){
            entryImage = (
                <div className="history-image point">
                    <div className="points-number">{this.props.entry.points}</div>
                    <div className="points">{this.props.entry.points > 1?"points":"point"}</div>
                </div>
            );
        }
        else {
            entryImage = (
                <div className={`history-image${imgClass}`}>
                    <Image 
                        isResponsive="false"
                        imgPath={image}
                        imgName="badge"
                    /> 
                </div>
            );
        }

        let entryText = (
            <div className={`history-text ${points?"point":""}`}>
                <span>{title}</span>
                <span className={`subtext${ask?" hide":""}`}>
                    &laquo;{subtext}&raquo;
                </span>
            </div>                        
        );

        return {entryImage, entryText};

    }
    
    render(){
        const { entry } = this.props;
        const blocs = this.generateBlocs(entry);

        return (
            <div className="history-entry">
                {blocs.entryImage}
                {blocs.entryText}
                <div className="history-date">
                    {this.formatDate(entry.created_at)}
                </div>
                
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/History/HistoryEntry/HistoryEntry.js